import React from "react";
import * as S from "./button.styles";

export const Button = (props) => {
  return <S.SubmitButton {...props}>{props.value}</S.SubmitButton>;
};
